
const pageTextConfig = {
    title: "Welcome Onboard!",
    description: "Your Gig has been submitted successfully and will be live in next 2 hours.",
    buttonText: "Explore Your Dashboard"
}

export default pageTextConfig